import BackIcon from "assets/icons/back.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isYeloCheckoutSession, partnerHomePath } from "utils/partnerSession.util";

const JEENY_HOME = "https://www.jeeny.me";

export default function PartnerBackButton() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const handleBack = () => {
    if (isYeloCheckoutSession()) {
      navigate(partnerHomePath());
      return;
    }
    window.location.href = JEENY_HOME;
  };

  return (
    <img
      src={BackIcon}
      alt="<"
      width="40px"
      height="40px"
      style={{ cursor: "pointer" }}
      className={i18n.language === "ar" ? "rotate" : ""}
      onClick={handleBack}
    />
  );
}
